import {
  DEFAULT_CCSD_CODE_COST_LIST_ERROR,
  DEFAULT_CCSD_CODE_COST_LIST_RECEIVED,
  DEFAULT_CCSD_CODE_COST_LIST_REQUEST,
  DEFAULT_CCSD_CODE_COST_LIST_UNLOAD,
  DEFAULT_CCSD_CODE_COST_SINGLE_REFRESHED,
  DEFAULT_CCSD_CODE_COST_LIST_ALL_LOADED,
} from '../constants';

const initialState = {
  defaultCcsdCodeCosts: [],
  isFetchingDefaultCcsdCodeCosts: false,
  isLoadingMoreDefaultCcsdCodeCosts: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case DEFAULT_CCSD_CODE_COST_LIST_UNLOAD:
      return { ...initialState };
    case DEFAULT_CCSD_CODE_COST_LIST_REQUEST:
      return { ...state, isFetchingDefaultCcsdCodeCosts: true, isLoadingMoreDefaultCcsdCodeCosts: true };
    case DEFAULT_CCSD_CODE_COST_LIST_RECEIVED: {
      const incoming = action.data['hydra:member'] || [];
      const merged = [...state.defaultCcsdCodeCosts, ...incoming];
      const unique = Array.from(new Set(merged.map((a) => a['@id']))).map((id) => merged.find((a) => a['@id'] === id));
      return { ...state, defaultCcsdCodeCosts: unique, isFetchingDefaultCcsdCodeCosts: false };
    }
    case DEFAULT_CCSD_CODE_COST_LIST_ALL_LOADED:
      return { ...state, isLoadingMoreDefaultCcsdCodeCosts: false };
    case DEFAULT_CCSD_CODE_COST_LIST_ERROR:
      return { ...state, isFetchingDefaultCcsdCodeCosts: false, isLoadingMoreDefaultCcsdCodeCosts: false };
    case DEFAULT_CCSD_CODE_COST_SINGLE_REFRESHED:
      return {
        ...state,
        defaultCcsdCodeCosts: state.defaultCcsdCodeCosts.map((item) =>
          item['@id'] === action.data['@id'] ? action.data : item
        ),
      };
    default:
      return state;
  }
};

export default reducer;
